import { render } from "./CheckoutTable.vue?vue&type=template&id=3bbd8271"
import script from "./CheckoutTable.vue?vue&type=script&lang=js"
export * from "./CheckoutTable.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__